//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export enum ACCOUNT_SETTINGS_ROUTES {
  SOCIAL = 'account-settings.social',
  ANALYTICS = 'account-settings.analytics',
  TRACKING = 'account-settings.tracking',
  RIGHTS = 'account-settings.rights',
  USERS = 'account-settings.users',
  MOBILE = 'account-settings.mobile',
  EMAIL = 'account-settings.email',
  EMAIL_SETTINGS = 'account-settings.creator-email-settings',
  WALLETS = 'account-settings.wallets',
  PRODUCT = 'account-settings.product',
  ACCOUNT = 'account-settings.account',
}

export interface ISidebarPage {
  state: ACCOUNT_SETTINGS_ROUTES;
  text: string;
}

export const SIDEBAR_PAGES: ISidebarPage[] = [
  {
    state: ACCOUNT_SETTINGS_ROUTES.SOCIAL,
    text: 'Social Media Accounts',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.ANALYTICS,
    text: 'Analytics Providers',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.TRACKING,
    text: 'Tracking Parameters',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.RIGHTS,
    text: 'Rights Requests',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.MOBILE,
    text: 'Mobile Notifications',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.EMAIL_SETTINGS,
    text: 'Email Settings',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.WALLETS,
    text: 'Campaigns Budget',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.EMAIL,
    text: 'Email Reports',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.PRODUCT,
    text: 'Product Catalog',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.USERS,
    text: 'Users',
  },
  {
    state: ACCOUNT_SETTINGS_ROUTES.ACCOUNT,
    text: 'My Account',
  },
];

export enum EMPLOYEE_VIEW_OPTIONS {
  DEV = 'DEV',
  DOGFOOD = 'DOGFOOD',
  GAMMA = 'GAMMA',
  RELEASED = 'RELEASED',
  OPTINRELEASED = 'OPTINRELEASED',
  CLIENT_MODE = 'CLIENT_MODE',
}

export const ACCOUNT_WITH_NO_PERMISSIONS = "You don't have any permissions";
export const ACCOUNT_WITH_NO_DEFAULT_HANDLE_SET =
  ' Missing a main Instagram account. You will not have full functionalities until an account is set as main.';
export const IG_REFRESH_CONNECTION =
  'There is an issue with your Instagram connection. Please re-select your Instagram account.';
export const MAIN_ACCOUNT_PERMISSION_DETAILS =
  'The main Instagram account will have more permissions such as automatic publishing and access to insights.';
export const PERMISSIONS_TOOLTIP =
  'Your connected Facebook Page will give you access to certain permissions in the Bazaarvoice Vibe app. In order to access all permissions, you must have the role of Admin on your connected Facebook page and authorize Bazaarvoice to access your account.';
export const OPTIONTYPE = 'igAccount';

export const OAUTH_PERMISSION = 'admin:create_or_update_user';
export const OAUTH_NETWORK_PARAM = 'oauth-network';
export const OAUTH_ERROR_PARAM = 'oauth-error';
export const OAUTH_ERROR_MSG = 'oauth-msg';
export const USE_MODAL_FLOW = 'use-modal-flow';
export const OAUTH_YOUTUBE_PARAM = 'youtube';
